// react
import React, { forwardRef } from 'react';
import styled from 'styled-components';

// react-transition-group
import { CSSTransition, SwitchTransition } from 'react-transition-group';

/**
 * Transition animates the entrance and exit of a component.
 */
export const Transition = forwardRef<HTMLDivElement, TransitionProps>(
  ({ children, path, speed = 125 }, ref) => {
    return (
      <SwitchTransition>
        <CSSTransition
          key={path}
          nodeRef={ref}
          timeout={speed}
          classNames='fade'
          unmountOnExit
        >
          <AnimatedOutlet ref={ref} speed={speed}>
            {children}
          </AnimatedOutlet>
        </CSSTransition>
      </SwitchTransition>
    );
  },
);

interface AnimatedOutletProps {
  speed?: number;
}
const AnimatedOutlet = styled.div<AnimatedOutletProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: visible;
  height: 100%;
  &.fade-enter {
    opacity: 0;
  }
  &.fade-enter-active {
    opacity: 1;
    transition-duration: ${(props) => props.speed}ms;
  }
  &.fade-exit {
    opacity: 1;
  }
  &.fade-exit-active {
    opacity: 0;
    transition-duration: ${(props) => props.speed}ms;
  }
`;

interface TransitionProps {
  children?: React.ReactNode;
  outlet?: React.ReactNode;
  path?: string;
  speed?: number;
}

Transition.displayName = 'Transition';

export default Transition;
